import { Injectable, LOCALE_ID, Inject } from '@angular/core';
import { environment } from '../environments/environment';
import * as mapboxgl from 'mapbox-gl';
import { GeoJson, MARKERS } from './map';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

@Injectable()
export class MapService {

  constructor(
    @Inject(LOCALE_ID) protected localeId: string
  ) {
		mapboxgl.accessToken = environment.mapbox.accessToken
    mapboxgl.geojson = environment.mapbox.geojson+"."+localeId
	}

	getMarkers(): Observable<any> {
		//get Markers from local GeoJson
		return of(MARKERS);
	}

}



// WEBPACK FOOTER //
// ./src/app/map.service.ts